module.exports = __webpack_public_path__ + "static/yonghyeon_lee-93babd1c0d727da391a8459f86418358.jpg";